import cartoon from './animation.json';
import realistic from './realistic-animation.json';

export const getEagleAnimation = style => style === 'realistic' ? realistic : cartoon;